import { Button } from 'antd';
import * as React from 'react';
import { useState } from 'react';

const css = require('./index.scss');
type placeType = 'left' | 'right';
export interface IBtn {
    place?: placeType;
    btnName?: string;
    className?: string;
    style?: Object;
    disable?: boolean;
    onClick?: () => void;
}

interface IAppProps {
    key?: any;
    className?: string;
    icon?: string; // 图标url
    title?: string; // 标题
    subject?: string; // app简介
    appName?: string; // app名称
    secondName?: string; // 副名称
    buttonGroup?: Array<IBtn>; // 按钮组
    onClick?: () => void;
    isShowStatus?: boolean; // 是否展示激活状态
    status?: boolean; // 激活状态
    expand?: any; // 扩展
}

export default function AppCard(props: IAppProps) {
    const [imgUrl, setImgUrl] = useState(props.icon || require('./img.default.svg'));
    let leftBtns = null;
    let rightBtns = null;
    React.useEffect(() => {
        setImgUrl(props.icon || require('./img.default.svg'));
    });
    if (Array.isArray(props.buttonGroup)) {
        leftBtns = props.buttonGroup.map((item, index) => item.place === 'left' && getBtns(item, index));
        rightBtns = props.buttonGroup.map((item, index) => item.place === 'right' && getBtns(item, index));
    }
    return (
        <div className={`${css.appCard} ${props.className || ''}`} key={props.key}>
            <div className={css.appCardWrapper}>
                <div className={css.wrapper} onClick={props.onClick} >
                    <img src={imgUrl} alt="" />
                    {
                        props.isShowStatus ?
                            <div className={props.status ? `${css.appStatus} ${css.appStatusActive}` : `${css.appStatus}`}>
                                {
                                    props.status ? '已激活' : '未激活'
                                }
                            </div> : ''
                    }
                    <div className={css.titleWrapper}>
                        <p className={`text-overflow ${css.title}`} >{props.title}</p>
                        {
                            props.secondName ?
                                <div className={css.secondName}>
                                    {props.secondName}
                                </div> : ''
                        }
                    </div>
                    <p className={`${css.subject} text-overflow-2`} style={{ WebkitBoxOrient: 'vertical' }} >{props.subject}</p>
                </div>
                {
                    props.buttonGroup && (
                        <div className={css.expand} >
                            <div className={css.expandLeft} >
                                {leftBtns}
                            </div>
                            <div className={css.expandRight} >
                                {rightBtns}
                            </div>
                            {props.expand}
                        </div>
                    )
                }
            </div>
        </div>
    );
}

function getBtns(item: IBtn, key: number) {
    return (
        <a
            key={key}
            className={`${css.activation} ${item.className || null}`}
            onClick={item.onClick}
            style={item.style}
        >
            {item.btnName}
        </a>
    );
}

/** 容器组件Props */
interface IContentProps {
    children?: JSX.Element;
    onClick?: () => void;
}
/** 容器组件 */
function Content(props: IContentProps) {
    const onClickHandler = () => { // 点击回调
        props.onClick();
    };

    if (props.onClick) {
        return (
            <a onClick={onClickHandler} className={`${css.content}`} >
                {props.children}
            </a>
        );
    } else {
        return (
            <div className={css.content} >
                {props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/components/AppCard/index.tsx